module.exports = __webpack_public_path__ + "img/imge1.9702ca13.png";